<template>
    <generic-crud :service='service' labelNome='nome_colecao'></generic-crud>
</template>
<script>

import GenericCrud from '../components/GenericCrud'
import ColecaoService from '../services/colecao-service'

export default {

  components: {
    GenericCrud
  },
  data () {
    return {
      service: ColecaoService
    }
  }

}
</script>

